import { createContext } from '@/utils/react-utils';
import React from 'react';

import { EventForm } from '../interfaces';
import { useEventSummary } from './useEventSummary';
import { useInteractions } from './useInteractions';

export type EventItemsContext = {
  items: EventForm[];
  isLoading?: boolean;
};

const [Context, useEventItems] = createContext<EventItemsContext>({
  name: 'ChecklistSummaryContext',
});

const EventItemsProvider: React.FC = ({ children }) => {
  const isFirstRender = React.useRef(true);
  const { setCurrentForm, setCurrentItem } = useInteractions();
  const { event } = useEventSummary();

  React.useEffect(() => {
    if (event?.items?.length && isFirstRender) {
      const { id, items } = event.items[0];
      const firstItemId = items[0].id;
      setCurrentForm(id);
      setCurrentItem(firstItemId);

      isFirstRender.current = false;
    }
  }, [event, setCurrentForm, setCurrentItem]);

  return (
    <Context
      value={{
        items: event?.items || [],
        isLoading: false,
      }}
    >
      {children}
    </Context>
  );
};

export { useEventItems, EventItemsProvider };
